import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {IncidentReportsService} from '../../services/incident-reports.service';
import {UrlService} from '../../services/url.service';
import {flatMap, switchMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
    templateUrl: 'incident-reports.component.html',
})
export class IncidentReportsComponent implements OnInit, OnDestroy {

    incidentReports: any[] = [];
    private $destroy = new Subject();

    constructor(public incidentReportsService: IncidentReportsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.incidentReportsService.getBuildingsRequest().pipe(takeUntil(this.$destroy)).subscribe();
        this.incidentReportsService.getIncidentTypesRequest().pipe(takeUntil(this.$destroy)).subscribe();

        this.urlService
            .onUrlChange
            .pipe(
                tap(() => this.incidentReportsService.tabId = this.urlService.queryParams['tab']),
                switchMap(() => this.incidentReportsService.getDataByQueryParams(true))
            )
            .subscribe();
        this.urlService.setQueryParams('allIncidentReports');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.incidentReportsService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.incidentReportsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports.component.ts